import Vue from 'vue';
import Router from 'vue-router';
import Detect from '@/plugins/detect';
import store from './store';

Vue.use(Router);

console.log('Is mobile?', Detect.isMobile());

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: () => import(/* webpackChunkName: "get-started" */ '@/views/GetStarted.vue'),
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import(/* webpackChunkName: "sign-up" */ '@/components/SignUp.vue'),
        meta: { requiresGuest: true, plan: 'pro' },
    },
    {
        path: '/sign-up/free',
        name: 'sign-up-free',
        component: () => import(/* webpackChunkName: "signup-free" */ '@/components/SignUp.vue'),
        meta: { requiresGuest: true, plan: 'free' },
    },
    {
        path: '/',
        component: () => import(/* webpackChunkName: "layoud-centered" */ '@/views/LayoutCentered.vue'),
        children: [
            {
                path: '/demo-account',
                name: 'demo-account',
                component: () => import(/* webpackChunkName: "sign-in" */ '@/views/DemoAccountSignin.vue'),
            },
            {
                path: '/demo-signup',
                name: 'demo-signup',
                component: () => import(/* webpackChunkName: "sign-in" */ '@/views/DemoAccountSignup.vue'),
            },
            {
                path: '/sign-in',
                name: 'sign-in',
                component: () => import(/* webpackChunkName: "sign-in" */ '@/components/SignIn.vue'),
                meta: { requiresGuest: true },
            },
            {
                path: '/forgot-password',
                name: 'forgot-password',
                component: () => import(/* webpackChunkName: "forgot-password" */ '@/components/ForgotPassword.vue'),
            },
            {
                path: '/reset-password/:token/:email',
                name: 'reset-password',
                component: () => import(/* webpackChunkName: "reset-password" */ '@/components/ResetPassword.vue'),
            },
            {
                path: '/confirm-secure/:token/:email',
                name: 'confirm-secure',
                component: () => import(/* webpackChunkName: "create-password" */ '@/components/CreatePassword.vue'),
            },
        ],
    },
    {
        path: '/sign-out',
        name: 'sign-out',
        component: () => import(/* webpackChunkName: "sign-out" */'@/views/SignOut.vue'),
    },

    {
        path: '/ack/:incidentHash-:userHash-:incidentId-:userId',
        name: 'acknowledge',
        component: () => import(/* webpackChunkName: "acknowledge" */ '@/views/Acknowledge.vue'),
    },


    // Authentication required beyond this point...
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: { requiresAuth: true, title: ' ' },
        component: () => import(/* webpackChunkName: "dashboard-view" */ '@/views/DashboardView.vue'),
    },
    {
        path: '/monitors',
        name: 'monitors',
        meta: { requiresAuth: true },
        component: Detect.isMobile()
            ? () => import(/* webpackChunkName: "monitors-list-m" */ '@/views/mobile/MonitorsListView.vue')
            : () => import(/* webpackChunkName: "monitors-list-d" */ '@/views/desktop/MonitorsListView.vue'),
        children: [
            {
                name: 'monitors-edit',
                path: ':id/edit',
                component: () => import(/* webpackChunkName: "edit-monitor" */ '@/components/dialogs/EditMonitor.vue'),
            },
            {
                name: 'monitors-add',
                path: 'add',
                component: () => import('@/components/dialogs/EditMonitor.vue'),
            },
        ],
    },
    {
        path: '/monitors/:id',
        name: 'monitors-view',
        meta: { requiresAuth: true },
        component: Detect.isMobile()
            ? () => import(/* webpackChunkName: "monitor-view-m" */ '@/views/mobile/MonitorView.vue')
            : () => import(/* webpackChunkName: "monitor-view-d" */ '@/views/desktop/MonitorView.vue'),
        children: [
            {
                name: 'monitor-edit',
                path: 'edit',
                component: () => import('@/components/dialogs/EditMonitor.vue'),
            },
        ],
    },
    {
        path: '/outages',
        name: 'outages',
        meta: { requiresAuth: true },
        component: Detect.isMobile()
            ? () => import(/* webpackChunkName: "outages-list-m" */ '@/views/mobile/OutagesListView.vue')
            : () => import(/* webpackChunkName: "outages-list-d" */ '@/views/desktop/OutagesListView.vue'),
    },
    {
        path: '/outages/:id',
        name: 'incidents-view',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "outage-view-m" */ '@/views/mobile/OutageView.vue'),
    },
    {
        path: '/reports',
        name: 'reports',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "reports-view" */ '@/views/desktop/ReportsView.vue'),
        children: [
            {
                name: 'reports-add',
                path: 'create',
                component: () => import(/* webpackChunkName: "create-report" */ '@/components/dialogs/CreateReport.vue'),
            },
            {
                name: 'reports-edit',
                path: 'edit/:id',
                component: () => import('@/components/dialogs/CreateReport.vue'),
            },
        ],
    },
    {
        path: '/status-pages',
        name: 'status-pages',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "status-pages" */ '@/views/desktop/StatusPagesView.vue'),
        children: [
            {
                name: 'status-pages-add',
                path: 'create',
                component: () => import(/* webpackChunkName: "create-status-page" */ '@/components/dialogs/CreateStatusPage.vue'),
            },
            {
                name: 'status-pages-edit',
                path: 'edit/:id',
                component: () => import('@/components/dialogs/CreateStatusPage.vue'),
            },
        ],
    },
    {
        path: '/account',
        name: 'account',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "account-view" */ '@/views/mobile/AccountView.vue'),
    },
    {
        path: '/account/profile',
        name: 'profile',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "profile-view" */ '@/views/ProfileView.vue'),
    },
    {
        path: '/account/password',
        name: 'password',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "password-view" */ '@/views/PasswordView.vue'),
    },
    {
        path: '/account/delete',
        name: 'cancelation',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "delete-account-view" */ '@/views/DeleteAccountView.vue'),
    },
    {
        path: '/account/apps',
        name: 'features',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "features-view" */ '@/views/FeaturesView.vue'),
        children: [
            {
                name: 'features.keyword-monitoring',
                path: 'keyword-monitoring',
                component: () => import('@/components/features/KeywordMonitoring.vue'),
            },
            {
                name: 'features.group-monitors',
                path: 'group-monitors',
                component: () => import('@/components/features/GroupMonitors.vue'),
            },
            {
                name: 'features.http-custom-status',
                path: 'http-custom-status',
                component: () => import('@/components/features/HttpCustomStatus.vue'),
            },
            {
                name: 'features.http-custom-headers',
                path: 'http-custom-headers',
                component: () => import('@/components/features/HttpCustomHeaders.vue'),
            },
            {
                name: 'features.http-custom-method',
                path: 'http-custom-method',
                component: () => import('@/components/features/HttpCustomMethod.vue'),
            },
            {
                name: 'features.custom-timeout',
                path: 'custom-timeout',
                component: () => import('@/components/features/CustomTimeout.vue'),
            },
            {
                name: 'features.custom-interval',
                path: 'custom-interval',
                component: () => import('@/components/features/CustomInterval.vue'),
            },
            {
                name: 'features.custom-locations',
                path: 'custom-locations',
                component: () => import('@/components/features/CustomLocations.vue'),
            },
            {
                name: 'features.service-ping',
                path: 'service-ping',
                component: () => import('@/components/features/ServicePing.vue'),
            },
            {
                name: 'features.service-tcp-port',
                path: 'service-tcp-port',
                component: () => import('@/components/features/ServiceTcpPort.vue'),
            },
            {
                name: 'features.team-management',
                path: 'team-management',
                component: () => import('@/components/features/TeamManagement.vue'),
            },
            {
                name: 'features.maintenance-window',
                path: 'maintenance-window',
                component: () => import('@/components/features/MaintenanceWindow.vue'),
            },
            {
                name: 'features.custom-reports',
                path: 'custom-reports',
                component: () => import('@/components/features/CustomReports.vue'),
            },
            {
                name: 'features.status-page',
                path: 'status-page',
                component: () => import('@/components/features/StatusPage.vue'),
            },
            // Apps
            {
                name: 'features.channel-webhook',
                path: 'channel-webhook',
                component: () => import('@/components/features/ChannelWebhook.vue'),
            },
            {
                name: 'features.channel-sms',
                path: 'channel-sms',
                component: () => import('@/components/features/ChannelSms.vue'),
            },
            {
                name: 'features.channel-pagerduty',
                path: 'channel-pagerduty',
                component: () => import('@/components/features/ChannelPagerduty.vue'),
            },
            {
                name: 'features.channel-pushover',
                path: 'channel-pushover',
                component: () => import('@/components/features/ChannelPushover.vue'),
            },
            {
                name: 'features.channel-telegram',
                path: 'channel-telegram',
                component: () => import('@/components/features/ChannelTelegram.vue'),
            },
            {
                name: 'features.channel-slack',
                path: 'channel-slack',
                component: () => import('@/components/features/ChannelSlack.vue'),
            },
            {
                name: 'features.channel-email',
                path: 'channel-email',
                component: () => import('@/components/features/ChannelEmail.vue'),
            },
            {
                name: 'features.channel-phonecall',
                path: 'channel-phonecall',
                component: () => import('@/components/features/ChannelPhonecall.vue'),
            },
        ],
    },
    {
        path: '/account/help',
        name: 'help',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "help-view" */ '@/views/HelpView.vue'),
    },
    {
        path: '/account/team-users',
        name: 'manage-users',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "users-view" */ '@/views/TeamUsers.vue'),
    },
    {
        path: '/account/recipients',
        name: 'manage-recipients',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "recipients-view" */ '@/views/ManageRecipients.vue'),
    },
    {
        path: '/account/subscription',
        name: 'subscription',
        redirect: '/account/subscription/plan',
        meta: { requiresAuth: true, title: 'router.subscription' },
        component: () => import('@/views/SubscriptionView.vue'),
        children: [
            {
                path: 'plan',
                name: 'plan',
                component: () => import('@/components/subscription/Plan.vue'),
                meta: { title: 'router.subscription' },
            },
            {
                path: 'invoicing',
                name: 'invoicing',
                component: () => import('@/components/subscription/Invoicing.vue'),
                meta: { title: 'router.subscription' },
            },
            {
                path: 'payment',
                name: 'payment',
                component: () => import('@/components/subscription/Payment.vue'),
                meta: { title: 'router.subscription' },
            },
        ],
    },
];

const router = new Router({
    routes,

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    },
}); // §new Router()

router.onError((error) => {
    if (/loading chunk [a-z0-9-]+ failed./i.test(error.message) && navigator.onLine) {
        console.log('Router Chunk Error, reloading...');
        if (window.Bugsnag) {
            window.Bugsnag.notify(error);
        }
        setTimeout(() => { window.location.reload(); }, 500);
    }
});

router.beforeEach((to, from, next) => {
    // Check if we're in a callback
    if (to.name === 'dashboard' && window.location.search.startsWith('?connect=pagerduty')) {
        next({ name: 'features.channel-pagerduty' });
        return;
    }
    // Check if next route requires authentication
    if (to.matched.some(record => record.meta.requiresAuth)) {
        console.log('[ROUTER] Matched requiresAuth route, checking for signed in user');
        if (!store.getters['user/isAuthenticated']) {
            console.log('[ROUTER] NOT Authenticated, redirecting to sign-in...');
            next({
                name: 'sign-in',
                query: { redirect: to.fullPath },
            });
            return;
        }

        // Load user & team if not already loaded
        if (!store.getters['user/loaded']) {
            console.log('%c ROUTER %c Loading user...', 'font-weight: bold; color: #99FFAA; background: #333;', 'color: inherit; background: inherit;');
            store.dispatch('user/load').then(() => {
                console.log('%c ROUTER %c User ID loaded: ', 'font-weight: bold; color: #99FFAA; background: #333;', 'color: inherit; background: inherit;', `${process.env.NODE_ENV}/${store.getters['user/id']}`);
                if (typeof dataLayer !== 'undefined') {
                    // https://support.google.com/tagmanager/answer/4565987?hl=en
                    dataLayer.push({ user_id: `${process.env.NODE_ENV}${store.getters['user/id']}` });
                }
                // console.log(store.getters['user/current']);
                if (window.Bugsnag) {
                    window.Bugsnag.setUser(
                        store.getters['user/current'].id,
                        store.getters['user/current'].attributes.email,
                        `${store.getters['user/current'].attributes.firstName} ${store.getters['user/current'].attributes.lastName}`,
                    );
                }
                console.log('%c ROUTER %c Team ID loaded: ', 'font-weight: bold; color: #99FFAA; background: #333;', 'color: inherit; background: inherit;', store.getters['team/id']);
                console.log('%c ROUTER %c Loading preferences...', 'font-weight: bold; color: #99FFAA; background: #333;', 'color: inherit; background: inherit;');
                store.dispatch('user/loadPreferences');
                console.log('%c ROUTER %c Navigating to next()', 'font-weight: bold; color: #99FFAA; background: #333;', 'color: inherit; background: inherit;');
                next();
            }).catch((error) => {
                // @link https://github.com/axios/axios#handling-errors
                console.log('[ROUTER] ERROR LOADING USER: ', error);
                if (error.response) {
                    // the response wasn't that good
                    if (error.response.status === 401) {
                        return store.dispatch('user/logout')
                            .then(() => next({ name: 'sign-in' }));
                    }
                    return router.app.$root.$emit('show-snackbar', {
                        message: `There was a problem connecting to server (HTTP Code ${error.response.status})`,
                    });
                }
                if (error.request) {
                    return router.app.$root.$emit('show-snackbar', {
                        message: `There was an issue sending a request to the server: ${error.message}`,
                    });
                }
                router.app.$root.$emit('show-snackbar', {
                    message: `Error: ${error.message}`,
                });
                if (typeof Bugsnag !== 'undefined') {
                    Bugsnag.notify(error);
                }
                return store.dispatch('user/logout')
                    .then(() => next({ name: 'sign-in' }));
            });

            console.log('[ROUTER] beforeEach done.');
            return;
        }
    }

    // Check if next route is a guest-only page (such as Sign In)
    if (to.matched.some(record => record.meta.requiresGuest)) {
        if (store.getters['user/isAuthenticated']) {
            // User already authenticated, redirect to dashboard instead
            next({ name: 'dashboard' });
            return;
        }
    }

    if (typeof dataLayer !== 'undefined'
        && typeof dataLayer.push === 'function') {
        dataLayer.push({
            'gtm.oldUrlFragment': from.path,
            'gtm.newUrlFragment': to.path,
        });
    }

    next(); // make sure to always call next()!
}); // §.beforeEach

export default router;
